import { Injectable, signal, effect, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    theme = signal<'light' | 'dark'>('light');

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        if (isPlatformBrowser(this.platformId)) {
            const savedTheme = localStorage.getItem('theme') as 'light' | 'dark';
            if (savedTheme) {
                this.theme.set(savedTheme);
            } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                this.theme.set('dark');
            }
        }

        effect(() => {
            const currentTheme = this.theme();
            if (isPlatformBrowser(this.platformId)) {
                localStorage.setItem('theme', currentTheme);
                if (currentTheme === 'dark') {
                    document.documentElement.classList.add('dark');
                    document.documentElement.dataset['agThemeMode'] = 'dark-theme';
                } else {
                    document.documentElement.classList.remove('dark');
                    document.documentElement.dataset['agThemeMode'] = 'light-theme';
                }
            }
        });
    }

    setTheme(theme: 'light' | 'dark') {
        this.theme.set(theme);
    }

    toggleTheme() {
        this.theme.update(current => current === 'light' ? 'dark' : 'light');
    }
}
